import { apiClient } from "../../../lib/apiClient";
import type { TypeContract } from "../types/typeContract";
import type { ApiResponse } from "../../../types/apiResponse";

const fetchTypeContracts = async (): Promise<ApiResponse<TypeContract[]>> => {
  return apiClient<ApiResponse<TypeContract[]>>('/v1/contratos/tipos', {
    method: "GET"
  });
};

export default fetchTypeContracts;
